import React from "react";
import { Bell, Shield, User, Briefcase, CheckCircle2, Mail, Sheet } from "lucide-react";
import { cn } from "@/lib/utils";

const CONFIGS: Record<string, { Icon: React.ElementType; className: string }> = {
  warning:           { Icon: Shield,       className: "bg-status-warn-bg text-status-warn-fg" },
  confirm:           { Icon: Shield,       className: "bg-status-warn-bg text-status-warn-fg" },
  approval_reminder: { Icon: Mail,         className: "bg-status-warn-bg text-status-warn-fg" },
  sync_problem:      { Icon: Sheet,        className: "bg-status-warn-bg text-status-warn-fg" },
  candidate:         { Icon: User,         className: "bg-waves-mist text-waves-ink" },
  cand:              { Icon: User,         className: "bg-waves-mist text-waves-ink" },
  admin:             { Icon: Briefcase,    className: "bg-waves-mist text-waves-ink" },
  success:           { Icon: CheckCircle2, className: "bg-status-ok-bg text-status-ok-fg" },
  info:              { Icon: Bell,         className: "bg-waves-mist text-waves-ink" },
};

export function NotificationTypeIcon({
  type,
  unread,
  size = "md",
}: {
  type: string;
  unread: boolean;
  size?: "sm" | "md";
}) {
  const { Icon, className } = CONFIGS[type] ?? CONFIGS.info;
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center",
        size === "sm" ? "h-7 w-7 rounded-pill" : "h-9 w-9 rounded-nav",
        unread ? className : "bg-status-neutral-bg text-waves-muted",
      )}
    >
      <Icon size={size === "sm" ? 13 : 16} />
    </div>
  );
}
